<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <div>
        <h2 class="dashboard-title">Dashboard</h2>
        <!-- <p class="dashboard-subtitle">Menampilkan status dokumen, aset, dan penawaran harga</p> -->
      </div>
    </div>
  
    <!-- ALERT -->
    <!-- <div v-if="expiringList.length > 0" class="alert-box mb-4">
      <strong>⚠️ {{ expiringList.length }} item akan expired dalam 60 hari ke depan.</strong>
    </div>
    <div v-else class="alert-box alert-success mb-4">
      <strong>✅ Tidak ada item yang akan expired dalam 60 hari ke depan.</strong>
    </div> -->
  
    <!-- BAR CHARTS -->
    <div class="row g-4">
      <!-- 1. DOKUMEN -->
      <div class="col-lg-6" v-if="canViewDocument">
        <div class="card-modern h-100">
          <div class="card-header-modern d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Dokumen Perjanjian Kerja Sama</h5>
            <span class="badge bg-primary">Total: {{ documentSummary.total_document }}</span>
          </div>
          <div class="p-3">
            <div class="bar-chart">
              <div v-for="item in documentBars" :key="item.label" class="bar-item">
                <div class="bar-label">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
                <div class="bar-track">
                  <div class="bar-fill" :class="item.colorClass" :style="{ width: item.percent + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- 2. PENAWARAN HARGA -->
      <div class="col-lg-6" v-if="canViewOffer">
        <div class="card-modern h-100">
          <div class="card-header-modern d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Dokumen Penawaran Harga Biaya Angkut</h5>
            <span class="badge bg-secondary">Total: {{ penawaranSummary.total }}</span>
          </div>
          <div class="p-3">
            <div class="bar-chart">
              <div v-for="item in penawaranBars" :key="item.label" class="bar-item">
                <div class="bar-label">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
                <div class="bar-track">
                  <div class="bar-fill" :class="item.colorClass" :style="{ width: item.percent + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- 3. LAPTOP / PC -->
      <div class="col-lg-6" v-if="canViewAsset">
        <div class="card-modern h-100">
          <div class="card-header-modern d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Laptop / PC</h5>
            <span class="badge bg-info">Total: {{ assetLaptopSummary.total_asset }}</span>
          </div>
          <div class="p-3">
            <div class="bar-chart">
              <div v-for="item in assetLaptopBars" :key="item.label" class="bar-item">
                <div class="bar-label">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
                <div class="bar-track">
                  <div class="bar-fill" :class="item.colorClass" :style="{ width: item.percent + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- 4. INFRASTRUKTUR IT -->
      <div class="col-lg-6" v-if="canViewAsset">
        <div class="card-modern h-100">
          <div class="card-header-modern d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Infrastruktur IT</h5>
            <span class="badge bg-info">Total: {{ assetInfraSummary.total_asset }}</span>
          </div>
          <div class="p-3">
            <div class="bar-chart">
              <div v-for="item in assetInfraBars" :key="item.label" class="bar-item">
                <div class="bar-label">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </div>
                <div class="bar-track">
                  <div class="bar-fill" :class="item.colorClass" :style="{ width: item.percent + '%' }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardViewJs from './DashboardView';
export default DashboardViewJs;
</script>

<style scoped>
.bar-chart {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.bar-item {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.bar-label {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  color: #495057;
}

.bar-track {
  height: 24px;
  background: #e9ecef;
  border-radius: 6px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 6px;
  transition: width 0.6s ease;
  min-width: 2px;
}

.bar-fill.bg-active {
  background: linear-gradient(90deg, #198754, #20c997);
}

.bar-fill.bg-expired {
  background: linear-gradient(90deg, #dc3545, #e35d6a);
}

.bar-fill.bg-soon {
  background: linear-gradient(90deg, #ffc107, #ffda6a);
}
.bar-fill.bg-superseded {
  background: linear-gradient(90deg, #6c757d, #adb5bd);
}

.alert-box {
  background: #fff3cd;
  border: 1px solid #ffecb5;
  color: #664d03;
  padding: 0.75rem 1rem;
  border-radius: 8px;
}

.alert-box.alert-success {
  background: #d1e7dd;
  border-color: #badbcc;
  color: #0f5132;
}
</style>